import React from 'react'

import EntityPage from '../components/EntityPage'
import { personLabel } from '../api/people'

const People: React.FC = () => (
  <EntityPage
    entity="people"
    title="👥 People"
    description="One row per traveler — couples share a group. Real names live only here; everywhere else people are shown by nickname or first name."
    addLabel="Add person"
    emptyHint="No one here yet — add the first traveler."
    columns={[
      { key: 'group_name', label: 'Group' },
      { key: 'name', label: 'Name' },
      { key: 'nickname', label: 'Shows as', render: (row) => (row.nickname ? row.nickname : personLabel(row)) },
      { key: 'phone', label: 'Phone' },
      { key: 'email', label: 'Email' },
      { key: 'notes', label: 'Notes' },
    ]}
    fields={[
      { name: 'name', label: 'Name', type: 'text', required: true, placeholder: 'Full name' },
      { name: 'group_name', label: 'Group (couple or solo)', type: 'text', placeholder: 'e.g. Paul & Crista' },
      { name: 'phone', label: 'Phone', type: 'text' },
      { name: 'email', label: 'Email', type: 'text' },
      { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'dietary needs, kids, anything' },
    ]}
    blank={{}}
  />
)

export default People
